import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaUpload } from 'react-icons/fa';
import { createCategory, updateCategory } from '../../actions/categoryActions';
import { CATEGORY_CREATE_RESET, CATEGORY_UPDATE_RESET } from '../../constants/categoryConstants';
import Loader from '../ui/Loader';

const CategoryForm = ({ category, onClose }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  
  const categoryCreate = useSelector((state) => state.categoryCreate);
  const { loading: loadingCreate, success: successCreate } = categoryCreate;
  
  const categoryUpdate = useSelector((state) => state.categoryUpdate);
  const { loading: loadingUpdate, success: successUpdate } = categoryUpdate;
  
  useEffect(() => {
    if (category) {
      setName(category.name);
      setDescription(category.description || '');
      setImageUrl(category.image_url || '');
      if (category.image_url) {
        setImagePreview(category.image_url);
      }
    }
    
    // Close the modal after successful operation
    if (successCreate || successUpdate) {
      dispatch({ type: CATEGORY_CREATE_RESET });
      dispatch({ type: CATEGORY_UPDATE_RESET });
      onClose();
    }
  }, [dispatch, category, successCreate, successUpdate, onClose]);
  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  
  const submitHandler = (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    
    if (image) {
      formData.append('image', image);
    } else if (imageUrl) {
      // For backward compatibility, allow keeping an existing image_url
      formData.append('image_url', imageUrl);
    }
    
    if (category) {
      dispatch(updateCategory(category.id, formData));
    } else {
      dispatch(createCategory(formData));
    }
  };
  
  return (
    <form onSubmit={submitHandler}>
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">分类名称</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full p-2 border rounded"
          required
        />
      </div>
      
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">描述</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full p-2 border rounded"
          rows={3}
        />
      </div>
      
      <div className="mb-6">
        <label className="block text-gray-700 mb-2">分类图片</label>
        
        {imagePreview ? (
          <div className="mb-4">
            <img
              src={imagePreview}
              alt="Category"
              className="w-full h-40 object-cover rounded"
            />
          </div>
        ) : (
          <div className="w-full h-40 bg-gray-200 rounded flex items-center justify-center mb-4">
            <span className="text-gray-500">暂无图片</span>
          </div>
        )}
        
        <div className="relative">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="hidden"
            id="category-image-upload"
            ref={fileInputRef}
          />
          <button
            type="button"
            onClick={triggerFileInput}
            className="w-full bg-gray-100 text-gray-800 py-2 px-4 rounded border flex items-center justify-center hover:bg-gray-200 cursor-pointer"
          >
            <FaUpload className="mr-2" />
            选择图片
          </button>
        </div>
      </div>
      
      <div className="flex justify-end space-x-3">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 border rounded text-gray-600 hover:bg-gray-100"
        >
          取消
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          disabled={loadingCreate || loadingUpdate}
        >
          {loadingCreate || loadingUpdate ? (
            <Loader size="sm" />
          ) : category ? (
            '更新分类'
          ) : (
            '添加分类'
          )}
        </button>
      </div>
    </form>
  );
};

export default CategoryForm;
